export var AnnouncementStatusType;
(function (AnnouncementStatusType) {
    AnnouncementStatusType[AnnouncementStatusType["OUT_DATE"] = 1] = "OUT_DATE";
    AnnouncementStatusType[AnnouncementStatusType["STOP"] = 2] = "STOP";
    AnnouncementStatusType[AnnouncementStatusType["NOT_START"] = 3] = "NOT_START";
    AnnouncementStatusType[AnnouncementStatusType["START"] = 4] = "START";
})(AnnouncementStatusType || (AnnouncementStatusType = {}));
//# sourceMappingURL=AnnouncementStatusType.js.map